import { useCallback } from "react";
import { gql, useMutation } from "@apollo/client";

import { ContextValue, ReducerType } from "../types";
import { BOX_RETURN_QA_BASE } from "../helpers/fragments";

/**
 * This context hook adds a method calling an endpoint to mark the box return
 * as approved.
 */
export default function useApproveBox(context: ContextValue) {
  const { stateRef, setErrors, checkForErrors, dispatch } = context;

  const onError = useCallback(
    (err) => {
      setErrors([err.message]);
    },
    [setErrors]
  );

  const onCompleted = useCallback(
    function onCompleted({ qaApproveBoxReturn: res }) {
      if (checkForErrors(res)) return;
      const { boxReturn } = res;
      dispatch({
        type: ReducerType.setBoxReturn,
        payload: { boxReturn },
      });
    },
    [dispatch]
  );

  const [mutate] = useMutation(GQL, { onCompleted, onError });

  context.approveBox = useCallback(
    function approveBox() {
      const { boxShipmentId } = stateRef.current;
      const variables = {
        boxReturnId: boxShipmentId,
      };
      mutate({ variables });
    },
    [mutate, stateRef]
  );

  return context;
}

const GQL = gql`
  mutation QAApproveBoxReturn($boxReturnId: ID!) {
    qaApproveBoxReturn(boxReturnId: $boxReturnId) {
      success
      errorMessage
      errorData
      boxReturn {
        ...BoxReturnQABase
      }
    }
  }
  ${BOX_RETURN_QA_BASE}
`;
